// Constants
import { BREAKPOINTS } from '@/common/constants';

// Helpers
import getImageBySize from './getImageBySize';

/**
 * Format images list to a srcset array (media/srcset)
 *
 * @param {array} images - List of images
 * @param {object} formats - List of image formats (constants)
 * @returns {[]}
 */
const formatSrcSet = (images, formats) => {
  const srcSet = [];

  if (images?.length > 0 && formats) {
    images.map((image) =>
      srcSet.push({
        media: `(min-width: ${BREAKPOINTS[image.destination]}px)`,
        srcset: getImageBySize(image.url, formats[image.destination]),
      }),
    );

    srcSet.sort((a, b) => {
      const minWidthA = parseInt(a.media.match(/\d+/)[0], 10);
      const minWidthB = parseInt(b.media.match(/\d+/)[0], 10);

      return minWidthB - minWidthA;
    });
  }

  return srcSet;
};

export default formatSrcSet;
